<template><!--陌撩漂流瓶隐私政策摘要-->
  <div class="privacyList">

    <div>
      <div style="text-align: center; margin: 20px 0;">
        <h2>陌撩漂流瓶隐私政策摘要</h2>
      </div>

      <table border="1"
             style="border:1px solid rgba(0,0,0,.1);min-height:25px;line-height:25px;text-align:left;
             border-collapse:collapse;table-layout:fixed;width:100%;word-break:break-all;word-wrap:break-word;color:rgba(0,0,0,.9);
             margin: 20px 0;">
        <tr>
          <th style="padding:5px 2px;text-align:center;width:10%">场景/业务功能</th>
          <th style="padding:5px 2px;text-align:center;width:60%">收集个人信息种类</th>
          <th style="padding:5px 2px;text-align:center;width:30%">收集目的</th>
        </tr>

        <tr>
          <td> 注册登录</td>
          <td> 手机号码或微信授权、昵称、年龄、性别、个人照片（用做头像）、剪切板验证码信息</td>
          <td> 用于为用户注册创建账号</td>
        </tr>
        <tr>
          <td> 消息聊天</td>
          <td> 相册、相机、麦克风、地理位置</td>
          <td> 用于为用户提供发消息时拍摄照片或语音交互或发送位置信息的服务</td>
        </tr>
        <tr>
          <td> 首页交友/附近</td>
          <td> 地理位置</td>
          <td> 用于为用户基于地理位置的推荐</td>
        </tr>
        <tr>
          <td> 个人主页</td>
          <td>
            我的照片、昵称、性别、生日、身高、体重、职业、地区、交友目的、我的个性标签
          </td>
          <td> 用于为用户完善网络身份标识，提供更高质量的相关服务</td>
        </tr>
        <tr>
          <td> 信息发布</td>
          <td> 相册、相机、麦克风、地理位置、发布信息、关注关系、分享历史、点赞等信息</td>
          <td> 用于为用户提供信息发布、关注</td>
        </tr>
        <tr>
          <td> 匹配</td>
          <td> 地理位置</td>
          <td> 用于为用户基于地理位置的推荐</td>
        </tr>
        <tr>
          <td> 实名认证</td>
          <td> 真实姓名、身份证号码、生物识别特征</td>
          <td> 用于提供实名认证服务，进行身份核验涉及人脸识别信息时将会依法取得单独授权</td>
        </tr>
        <tr>
          <td> 提现</td>
          <td> 支付宝账户信息、身份认证信息</td>
          <td> 用于为用户提供提现服务</td>
        </tr>

        <tr>
          <td> 客服沟通</td>
          <td> 通信/通话记录和内容（包括用户的账户信息、提供的相关投诉材料等）、身份核验信息</td>
          <td> 用于为用户提供客服服务及争议处理</td>
        </tr>
        <tr>
          <td> 安全保障</td>
          <td> 设备相关信息，包括设备型号、操作系统版本、设置参数、设备配置、设备标识（IMEI/Android
            ID/OAID/IDFA/IDFV/MEID/UDID/SIM卡IMSI信息/ICCID/SIM卡状态/VAID/AAID等）、设备序列号、MAC地址、设备网络信息(运营商信息/WIFI信息/WIFI状态/WIFI列表/SSID/BSSID)、设备环境、软件列表/应用列表、运行中的进程信息、SDCard信息、传感器列表等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）
          </td>
          <td> 用于使用过程中对用户账号提供设备安全保障、账户安全风控保障</td>
        </tr>
        <tr>
          <td> 个性化推荐</td>
          <td> 设备信息、服务日志信息（浏览、点击、搜索、关注、发布信息）</td>
          <td> 用于提供更符合用户需求的个性化推荐服务</td>
        </tr>

      </table>

      <br>

      <div>
        根据《常见类型移动互联网应用程序必要个人信息范围规定》，陌撩漂流瓶App属于“即时通信类”App，即时通信类APP的基本功能服务为“提供文字、图片、语音等网络即时通信服务”，必要个人信息包括：1．注册用户移动电话号码；2．账号信息：账号、即时通信联系人账号列表。另外，基于陌撩漂流瓶的主要服务“推荐交友/附近”，还需要用户提供年龄、性别信息。
        我们所提供产品或服务的功能分别收集的个人信息类型，以及收集、使用个人信息的规则（例如收集和使用个人信息的目的、方式）如下：
        <p>
          <b>1.业务功能：注册成为用户。当您注册陌撩漂流瓶服务时，为完成创建账号，您需要提供以下信息：手机号码或微信授权、昵称、年龄、性别、个人照片（用做头像）、剪切板验证码信息（用于便捷完成验证码输入），收集这些信息是为了帮助你完成陌撩漂流瓶账户注册和使用社交功能。</b>
          我们会根据您在安装、访问及使用“陌撩漂流瓶”软件及相关服务的过程中或软件在后台运行时授予的具体权限收集您所使用的<b>设备相关信息，包括设备型号、操作系统版本、设置参数、设备配置、设备标识（IMEI/Android
          ID/OAID/IDFA/IDFV/MEID/UDID/SIM卡IMSI信息/ICCID/SIM卡状态/VAID/AAID等）、设备序列号、MAC地址、设备网络信息(运营商信息/WIFI信息/WIFI状态/WIFI列表/SSID/BSSID)、设备环境、软件列表/应用列表、运行中的进程信息、SDCard信息、传感器列表等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）</b>，用于保障软件与服务的安全运行、运营的质量及效率。服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关服务日志保存。包括您的浏览、点击查看和搜索查询内容、关注分享信息、发布信息，以及IP地址、浏览器的类型、运营商信息、使用的语言、访问日期和时间。
          请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
          <b>手机号码、个人照片属于敏感信息</b>，收集此类信息是为了满足国家法律法规的网络实名制要求以及完成陌撩漂流瓶账号的注册。
          <br> 若您不提供这类信息，您可能无法正常使用我们的服务。
        </p>
        <p>
          <b>2.业务功能：聊天。当您使用聊天服务时，我们没有要求您必须提供的信息。但为了保障您正常使用聊天服务，维护服务的正常运行，改进及优化我们的服务体验并保障您的账号安全，我们会收集和使用您的账号信息。</b>
          <br> 如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>相册权限、麦克风权限</b>。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
        </p>
        <p>
          <b>3.业务功能：首页交友/附近。当您使用推荐交友/附近服务及设置相关筛选项时，为向您推荐附近的用户并将您推荐给其他用户，您需要提供以下信息：个人位置信息。
            <br> 个人位置信息属于敏感信息。</b>
          <br> 若您不提供这类信息，您可能无法正常使用<b>推荐交友/附近</b>的服务。
          <br>
          在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>我的照片、昵称、性别、生日、身高、体重、职业、地区、交友目的、我的个性标签</b>（以下简称“个人信息”）。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
          <br>
          <b>我的照片、昵称、性别、生日、身高、体重、职业、地区、交友目的、我的个性标签等属于敏感信息。</b>
          <br>
          当您使用推荐交友/附近服务时，我们会根据您的日志信息、标签信息、位置信息、用户个人资料信息、个人筛选设置，向您提供个性化内容推荐服务，并根据您的位置信息与个人筛选设置向您进行排序展示。您可以在陌撩漂流瓶设置中自主控制个性化内容推荐服务的开启和关闭，可选择通过【我-右上角-设置-隐私与权限-个性化推荐】按钮关闭和打开个性化推荐服务，关闭后不会影响您正常使用推荐交友/附近的相关功能。当您选择关闭个性化推荐后，我们将无法为您提供个性化内容服务，我们会基于内容热度等非个性化因素向您展示、推荐内容。
        </p>
        <p>
          <b>4.业务功能：查看圈子。当您使用查看圈子服务时，我们没有要求您必须提供的信息。</b>
          <br> 在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>个人位置信息</b>。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
          <br> <b>个人位置信息属于敏感信息。</b>
          <br>
          当您查看圈子时，我们会根据您的日志信息、标签信息、位置信息、性别、个人筛选设置以及您的行为信息（即历史浏览、评论、赞、关注信息），向您提供个性化内容推荐服务，并根据您的历史行为信息与圈子内容标签向您进行排序展示。您可以在陌撩漂流瓶设置中自主控制个性化内容推荐服务的开启和关闭，可选择通过【我-右上角-设置-隐私与权限-个性化推荐】按钮关闭和打开个性化推荐服务，关闭后不会影响您正常使用圈子的相关功能。当您选择关闭个性化推荐后，我们将无法为您提供个性化内容服务，我们会基于内容热度等非个性化因素向您展示、推荐内容。
        </p>
        <p>
          <b>5.业务功能：发送圈子。当您使用发送圈子服务时，为提供圈子的素材，您需要提供以下权限、信息：相册权限、摄像头权限。 </b>
          <br> 若您不提供这类信息，您可能无法正常使用 <b>发送圈子 </b>的服务。
          <br> 在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>个人位置信息</b>。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
          <br> <b>个人位置信息属于敏感信息。 </b>
        </p>
        <p>
          <b>6. 业务功能：匹配。当您使用匹配服务时，为向您推荐附近的已匹配用户，您需要提供以下信息：个人位置信息。
            <br> 个人位置信息属于敏感信息。 </b>
          <br> 若您不提供这类信息，您可能无法正常使用匹配的服务。
        </p>
        <p>
          <b>7.业务功能：真人视频认证。当您使用真人视频认证服务时，您需要提供以下信息：个人生物识别信息中的面部特征信息。
            <br> 个人生物识别信息中的面部特征信息属于敏感信息。 </b>
          <br> 若您不提供这类信息，您可能无法正常使用 <b>真人视频认证 </b>的服务。
          <br> 若您不提供这类信息，您将无法使用 <b>擦肩而过 </b>的服务。
        </p>
        <p>
          <b>8.业务功能：支付功能。支付功能由与我们合作的第三方支付机构向您提供服务，第三方支付机构将会需要收集您的信息，我们将无法获取您的信息。拒绝提供信息仅会使您无法使用上述支付功能，但不影响您使用陌撩漂流瓶的其他功能。 </b>
        </p>
        <p>
          <b>9.业务功能：真人实名认证。在您申请提现或使用其他需实名认证的功能或服务时，为符合法律法规相关要求，保障你或其他用户的安全，或维护功能/服务的安全稳定，需要你提供真实身份信息以完成实名认证。当您选择真人实名认证服务时，为确认您所提供的身份信息为您本人信息且属实，需要您提供以下信息（根据实际业务场景情况可能有所不同）：真实姓名、身份证号及身份证核验授权，个人生物识别信息中的面部特征信息。
            <br>个人生物识别信息中的面部特征信息属于敏感信息 </b>，收集此类信息是为了满足国家法律法规的网络实名制要求，同时保证陌撩漂流瓶产品真实安全的社交氛围。若您不提供这类信息，您可能无法正常使用陌撩漂流瓶认证服务。
        </p>
        <p>
          <b>10.为了让您能够更好的接收消息提醒，我们需要您开启自启动以确保应用处于关闭或后台运行状态下可正常接受客户端推送消息，避免您遗漏消息，因此可能存在通过系统唤醒陌撩漂流瓶的自启动行为，这是保障消息能及时送达所必要的。您可以在手机设置中进行应用自启动管理关闭该权限，但关闭后可能导致您的消息接收延迟。 </b>
          <br> 为了统计投放/推广有效触达率，我们会在注册登录场景通过系统发送广播，获取华为应用市场相关广播信息，这些信息无法与您的真实身份相关联。这些信息将帮助我们分析、衡量相关服务的有效性。
        </p>
        <p>
          <b>11.我们会收集您的传感器信息（陀螺仪、步测器、光线、加速度、磁场、距离、旋转矢量等传感器信息），通过传感器获取设备状态（方向、角度、加速度等）拍摄时调整画面角度帮助您使用正确的角度体验产品或者语音时调整声音播放方式（听筒扬声器转换）为您提供更好的适配效果以及保障账号安全，为您提供安全、可信的产品与使用环境。 </b>
        </p>
        <p>
          12.我们提供的服务可能需要您在您的设备中开启您的<b>位置信息（地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）、通讯录的访问权限 </b>，以实现这些权限所涉及信息的收集和使用。您可以阅读陌撩漂流瓶设备权限清单，以了解陌撩漂流瓶申请和使用系统权限的情况。相应设备权限并不会默认开启，当涉及重要或敏感的设备权限时，我们会在您使用到相应业务功能时，另行弹窗再次征得您的同意后开启；
          <b>您可在您的设备设置功能中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。 </b>请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
        </p>
        <p>
          <b>13.您知悉并同意，对于您在使用产品及/或服务的过程中提供的联系方式（例如：联系电话），我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等；此外，我们也可能会以短信、电话的方式，为您提供您可能感兴趣的服务、功能或活动等商业性信息。但请您放心，如您不愿意接受此类信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。 </b>
        </p>
        <p>
          <b>14.若你提供的信息中含有其他用户的个人信息，在向陌撩漂流瓶提供这些个人信息之前，您需确保您已经取得合法的授权。</b>
        </p>
        <p>
          <b>15.您提供的信息，将在您使用本服务期间持续授权我们使用。在您注销账号或取消停止使用某项功能时，我们将根据适用法律法规的要求尽快停止使用使其匿名化或删除上述信息。</b>
        </p>
      </div>

      <br>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>

<style>

.privacyList {
  width: 92%;
  margin: auto;
  font-size: 14px;
  line-height: 26px;
}

.privacyList div {
  margin-bottom: 8px;
}

.privacyList h3 {
  margin: 8px 0;
}

.privacyList h4 {
  margin: 2px 0;
}

p {
  margin: 4px 0;
}

</style>
